module.exports = __webpack_public_path__ + "static/media/20.2776bb28.jpeg";